import React from 'react';
import { ReconciliationOutlined } from '@ant-design/icons';
import * as S from './styles';

export function Loading() {
	return (
		<>
			<S.Spinner />
			<ReconciliationOutlined className="loading-icon" />
		</>
	);
}
